import { render, staticRenderFns } from "./widzowieliska.vue?vue&type=template&id=36a9d908&"
import script from "./widzowieliska.vue?vue&type=script&lang=js&"
export * from "./widzowieliska.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports